import CommonHttpRequest from './common-http-request';

export default new CommonHttpRequest(process.env.REACT_APP_API_DOMAIN)